module.exports = __webpack_public_path__ + "img/svg/banner-card-mobile.a268692ece433d03f4f8301271c61266.svg";